import * as DialogPrimitive from '@radix-ui/react-dialog';
import { useTranslation } from 'react-i18next';
import { X } from 'lucide-react';
import { cn } from '@/lib/utils';
import { Sidebar } from './Sidebar';

export interface MobileNavProps {
 open: boolean;
 onOpenChange: (open: boolean) => void;
}

/**
 * Off-canvas navigation drawer used on screens narrower than `lg`. Reuses the
 * same `<Sidebar />` content so the menu stays consistent across breakpoints.
 */
export function MobileNav({ open, onOpenChange }: MobileNavProps) {
 const { t } = useTranslation();
 return (
 <DialogPrimitive.Root open={open} onOpenChange={onOpenChange}>
 <DialogPrimitive.Portal>
 <DialogPrimitive.Overlay
 className={cn(
 'fixed inset-0 z-40 bg-background lg:hidden',
 'data-[state=open]:animate-in data-[state=closed]:animate-out',
 'data-[state=open]:fade-in-0 data-[state=closed]:fade-out-0',
 )}
 />
 <DialogPrimitive.Content
 className={cn(
 'fixed inset-y-0 left-0 z-50 flex w-72 max-w-[85vw] flex-col bg-card shadow-xl lg:hidden',
 'data-[state=open]:animate-in data-[state=closed]:animate-out',
 'data-[state=open]:slide-in-from-left data-[state=closed]:slide-out-to-left',
 )}
 >
 <DialogPrimitive.Title className="sr-only">
 {t('nav.dashboard')}
 </DialogPrimitive.Title>
 <DialogPrimitive.Description className="sr-only">
 {t('common.command_palette_hint')}
 </DialogPrimitive.Description>
 <DialogPrimitive.Close
 className={cn(
 'absolute right-3 top-3 rounded-md p-1.5 text-muted-foreground',
 'hover:bg-accent hover:text-accent-foreground',
 'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring',
 )}
 aria-label={t('common.close_menu')}
 >
 <X className="h-4 w-4" />
 </DialogPrimitive.Close>
 <Sidebar
 collapsed={false}
 onNavigate={() => onOpenChange(false)}
 className="border-r-0"
 />
 </DialogPrimitive.Content>
 </DialogPrimitive.Portal>
 </DialogPrimitive.Root>
 );
}
